export const shadow = '0 0 5px 0 rgba(0,0,0,0.1)'
